import { render, staticRenderFns } from "./seconLabel.vue?vue&type=template&id=998f10fe"
import script from "./seconLabel.vue?vue&type=script&lang=js"
export * from "./seconLabel.vue?vue&type=script&lang=js"
import style0 from "./seconLabel.vue?vue&type=style&index=0&id=998f10fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports